import React from 'react'
import { useSelector } from 'react-redux'
import { selectFirstAddress } from '../../../store/address/address.selectors'
import { selectIsUserAccountEnabled } from '../../../store/userAccount/userAccount.selectors'
import s from '../../address/AddressContent.less'
import AddressDescription from '../../address/AddressDescription'
import AddressShareButton from '../../address/AddressShareButton'
import { AddressFavoriteButton } from '../../UserAccount/connected/userFavorites/FavoriteButton'

const ZoneContent = ({ titleContent }) => {
  const shouldDisplayFavoriteButton = useSelector(selectIsUserAccountEnabled)

  return (
    <div className={s.addressContent}>
      <div className={s.mainHeader}>
        {titleContent}
        <div className={s.actions}>
          <div className={s.actionBtnWrapper}>
            <AddressShareButton />
          </div>
          {shouldDisplayFavoriteButton && (
            <div className={s.actionBtnWrapper}>
              <AddressFavoriteButton />
            </div>
          )}
        </div>
      </div>
      <AddressDescription />
    </div>
  )
}

export default ZoneContent

export const CountryTitle = () => {
  const firstAddress = useSelector(selectFirstAddress)
  return (
    <h1 className={s.addressTitle}>
      <span className={s.locationMainAddress}>{firstAddress.countryLabel}</span>
    </h1>
  )
}

export const RegionTitle = () => {
  const firstAddress = useSelector(selectFirstAddress)
  return (
    <h1 className={s.addressTitle}>
      <span className={s.locationMainAddress}>{firstAddress.regionLabel}</span>
      <span className={s.locationSubAddress}>{firstAddress.regionCode}</span>
    </h1>
  )
}

export const DepartmentTitle = () => {
  const firstAddress = useSelector(selectFirstAddress)
  return (
    <h1 className={s.addressTitle}>
      <span className={s.locationMainAddress}>{firstAddress.departmentLabel}</span>
      <span className={s.locationSubAddress}>{firstAddress.departmentCode}</span>
    </h1>
  )
}
